module.exports = __webpack_public_path__ + "img/white-caret-up.1302c4ee.svg";